import { createContext, ReactNode, useEffect, useMemo, useState } from 'react';
import { Notification } from '@api/notifications/model/types.ts';
import { updateNotification } from '@api/notifications/apiService.ts';
import { NotificationContextValues } from '@app/types/core/notification.ts';
import { useDashboardSelector } from '@hooks/useDashboard';
import useDataFetcher from '@hooks/useDataFetcher/useDataFetcher.ts';
import { urls } from '@api/urls.ts';

const NotificationContext = createContext<NotificationContextValues | null>(
  null
);

interface NotificationProviderProps {
  children: ReactNode;
}

function NotificationProvider({ children }: NotificationProviderProps) {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const isNotificationOpened = useDashboardSelector(
    (state) => state.isNotificationOpened
  );
  const { data, mutate } = useDataFetcher<Notification[]>({
    url: urls.notifications.base,
    revalidateOnFocus: false,
  });

  useEffect(() => {
    if (isNotificationOpened) {
      notifications.map((item) => {
        if (!item.is_read) {
          setTimeout(() => UpdateIsRead(item.id), 2000);
        }
      });
    }
  }, [isNotificationOpened]);

  useEffect(() => {
    if (data) {
      setNotifications(data);
    }
  }, [data]);

  const getNotifications = () => {
    mutate();
  };

  const UpdateIsRead = (id: number) => {
    updateNotification(id, () => {
      getNotifications();
    });
  };

  const value = useMemo(
    () => ({
      notifications,
      getNotifications,
    }),
    [notifications]
  );

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
}

export { NotificationContext, NotificationProvider };
